<template>
  <div v-if="activeItem.res_data && activeItem.res_data.length > 0" class="element-list" :style="{'grid-template-columns': `repeat(auto-fill, ${option.itemWidth}px)`}">
    <div v-for="(item, index) in activeItem.res_data" :key="index" class="element-item">
      <div
        class="cover"
        :style="{ width: option.itemWidth + 'px', height: option.itemHeight + 'px' }"
        @click="
          showImg(
            item.watermark_image
              ?$func.ImageCdn('5', item.watermark_image)
              : $func.ImageCdn(activeItem.catetory, item.image)
          )
        "
      >
        <img
          v-if="item.watermark_image"
          :src="$func.ImageCdn('5', item.watermark_image)"
        />
        <img v-else :src="$func.ImageCdn(activeItem.catetory, item.image)" alt="" />
      </div>
      <div class="name" v-if="item.title && showTitle">
        {{ item.title }}
      </div>
    </div>
    <a-modal
      v-model="imgVisible"
      :destroy-on-close="true"
      :footer="null"
      width="auto"
      :closable="false"
      centered
      class="preViewModal"
      :bodyStyle="{ padding: 0 }"
      :dialogStyle="{ 'background-color': '32px' }"
    >
      <img :src="activeImg" class="preViewImg" @click="hide" alt="" />
    </a-modal>
  </div>
</template>

<script >
export default {
  name: 'PackageList',
  props: {
    activeItem: {
      type: Object,
      default: () => {}
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    option: {
      type: Object,
      default: () => {
        return {
          itemWidth: 148,
          itemHeight: 148
        }
      }
    }
  },
  data () {
    return {
      imgVisible: false,
      activeImg: ''
    }
  },
  components: {},
  computed: {},
  created () {},
  mounted () {},
  methods: {
    showImg (url) {
      this.imgVisible = true
      this.activeImg = url
    },
    hide () {
      this.imgVisible = false
    }
  }
}
</script>

<style lang='less' scoped>
.preViewModal {
  .ant-modal-content {
    background-color: red;
  }
  .preViewImg {
    max-width: 620px;
    cursor: pointer;
  }
}
.element-list {
  display: grid;

    grid-template-columns: repeat(auto-fill, 148px);
    grid-row-gap: 25px;
    grid-column-gap: 30px;
  .element-item {
    // margin-bottom: 25px;

    // &:not(:nth-of-type(5n)) {
    //   margin-right: 25px;
    // }
    .name {
      text-align: left;
      font-size: 14px;
      color: #999999;
      margin-top: 12px;
      line-height: 1;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &:hover {
      .cover {
        cursor: pointer;
        border: 1px solid @primary-color;
      }
      .name {
        color: @primary-color;
      }
    }
    .cover {
      width: 142px;
      height: 142px;
      box-sizing: border-box;
      border: 1px solid #f2f2f2;
      border-radius: 4px;
      overflow: hidden;
      position: relative;
      background-image: url('../../../assets/img/material_bg.jpg');

      img {
        display: block;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
}
</style>
